// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Grid } from '@material-ui/core';
import { PaymentOptionPropTypes, getCardIconByCardType } from 'utils';

import RadioButton from '../RadioButton';
import Checkbox from '../Checkbox';

const PaymentOption = ({ classes, children, variant, payment, isChecked, isDefault, onChange, ...inputProps }) => {
  const { cardExpMonth, cardExpYear, maskedNumber, networkType, subcardType } = payment;
  const last4digits = maskedNumber ? maskedNumber.slice(-4) : 'No card number info';
  const expiryDate = cardExpMonth && cardExpYear ? `, Exp ${cardExpMonth}/${cardExpYear}` : '';
  const title = maskedNumber && `${last4digits}${expiryDate}`;
  const isPLC = networkType === 'PLC';
  const cardType = isPLC && subcardType ? subcardType : networkType;

  const CardIcon = getCardIconByCardType(cardType);

  const labelWithIcon = (
    <>
      <Icon classes={{ root: classes.icon }} data-testid="card-icon">
        <CardIcon />
      </Icon>
      {title}
    </>
  );

  switch (variant) {
    case 'radio':
      return (
        <RadioButton
          label={labelWithIcon}
          checked={isChecked}
          onChange={onChange}
          value={maskedNumber}
          classes={{ label: classes.label }}
          {...inputProps}
        />
      );
    case 'checkbox':
      return (
        <>
          <Checkbox
            classes={{ label: classes.label }}
            label={labelWithIcon}
            checked={isChecked}
            onChange={onChange}
            {...inputProps}
          />
          {children}
        </>
      );
    case 'label':
      return (
        <Grid container alignItems="center" wrap="nowrap" data-testid="card-container">
          {labelWithIcon}
        </Grid>
      );
    default:
      return null;
  }
};

PaymentOption.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  children: PropTypes.node,
  variant: PropTypes.oneOf(['radio', 'checkbox', 'label']),
  payment: PaymentOptionPropTypes,
  isChecked: PropTypes.bool,
  isDefault: PropTypes.bool,
  onChange: PropTypes.func,
};

PaymentOption.defaultProps = {
  classes: {},
  variant: 'radio',
  payment: {},
  isChecked: false,
  isDefault: false,
  onChange: () => null,
};

export default PaymentOption;
